import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MuiSelect, { type SelectProps as MuiSelectProps } from '@mui/material/Select';
import { forwardRef } from 'react';

import { InfoIconButton } from '../InfoIconButton';

export type SelectProps = MuiSelectProps<string> & {
  infoTooltip?: string;
  helperText?: string;
};

/* any is okay here since we pass this ref to the `inputRef` prop of the MUI Select
an that is typed as React.Ref<any> */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type SelectRef = any;

export const Select = forwardRef<SelectRef, SelectProps>(function Select(
  { id, label, fullWidth = true, children, required, error, helperText, size = 'small', infoTooltip, ...rest },
  ref
) {
  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      error={error}
      size={size}
      sx={{ display: 'flex', flexDirection: 'row', gap: 1, minWidth: 'auto', ...rest.sx }}
    >
      <Box
        sx={{
          width: fullWidth ? '100%' : null,
        }}
      >
        {label ? (
          <InputLabel id={`${id}-label`} htmlFor={id} required={required}>
            {label}
          </InputLabel>
        ) : null}
        <MuiSelect
          fullWidth={fullWidth}
          labelId={`${id}-label`}
          label={label}
          inputRef={ref}
          error={error}
          size={size}
          sx={{
            minWidth: 100,
          }}
          {...rest}
          inputProps={{ id: id, ...rest.inputProps }}
        >
          {children}
        </MuiSelect>
        {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </Box>
      {infoTooltip ? <InfoIconButton tooltip={infoTooltip} sx={{ marginTop: 1 }} /> : null}
    </FormControl>
  );
});
